// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"_3y7FTWJqCSov9ZwJFfeJT9","paragraph--small":"_13MqXa56aEUcNcKj2-NBYa","paragraph--very-small":"_1nAFRMoI28oPbmH36_mOM_"};